import $ from 'jquery';

(function ($) {
	jQuery(document).off('click.bs.tab.data-api', '#nav [data-hover="tab"]');
	jQuery(document).on('mouseenter.bs.tab.data-api', '#nav [data-toggle="tab"], [data-hover="tab"]', function () {
		jQuery(this).tab('show');
	});

})(jQuery);

(function ($) {

	$(".nav-pills-link ").hover(function () {
		var data_id = $(this).data('id');

		// Shows the hovered floorplan, hides others
		$('.tab-pane').each(function () {
			var el = $(this);

			if (el.attr('id') == data_id)
				el.show();
			else
				el.hide();
		});
	});

	$(document).scroll(function () {
		var y = $(this).scrollTop();
		if (y > 500) {
			$('#btn-newsletter').fadeIn(200);
		} else {
			$('#btn-newsletter').fadeOut();
		}
	});

	$('#sidebarCollapse').on('click', function () {
		$('#sidebar-nav').toggleClass('open');
	});
	$('#close-sidebar').click(function () {
		$('#sidebar-nav').removeClass('open');
	});

	$('#filter-btn').on('click', function () {
		$('#filter-sidebar').toggleClass('open');
	});
	$('#close-filter').click(function () {
		$('#filter-sidebar').removeClass('open');
	});

	$('#funzione-link').on('click', function () {
		$('#funzione-menu').toggleClass('open');
	});


	$('#menuCollapse').on('click', function () {
		$('header').toggleClass('open');
		$('.ham').toggleClass('active');
	});
	$('#search-open').on('click', function () {
		$('#search').show(200);
		$('#search').addClass('open');
	});
	$('#search-close').on('click', function () {
		$('#search').hide(200);
		$('#search').removeClass('open');
	});

	$('#btn-brand').on('click', function () {
		$('#accordionListino').toggleClass('open');
		$(this).toggleClass('active');
	});
	$('#fbalsamoDetails').on('click', function () {
		$('#plus-1').toggleClass('rotate');
	});
	$('#shampooDetails').on('click', function () {
		$('#plus-2').toggleClass('rotate');
	});

	$(".smooth").on('click', function (event) {
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;

			$('html, body').animate({
				scrollTop: $(hash).offset().top
			}, 800, function () {
				window.location.hash = hash;
			});
		}
	});


})(jQuery);

